import { fromJS } from 'immutable';
import actions from '../constants';

const initialState = fromJS({});

const update = (state = initialState, action) => {
  switch (action.type) {
    case actions.SELECT_FINISH:
      return fromJS({
        ...action.payload,
        root: `organization-data/${action.payload.id}`,
      });
    default:
      return state;
  }
};

export default update;



// WEBPACK FOOTER //
// ./src/modules/organizations/reducers/selected.js